export default __webpack_public_path__ + "static/media/avatar-s-22.d21f2121.jpg";